module.exports = __webpack_public_path__ + "static/img/example-5.96475f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/example-5.png
// module id = AYFF
// module chunks = 2